import React from 'react';
import Modal from './Modal';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';
import styles from './checkoutError.less';

const CheckoutError = React.memo(({ i18n, fptiInfo }) => {
  return (
    <Modal titleId={i18n('label.checkout-error-title')} showOnMount={true}>
      <>
        <div className={styles.errorModalIcon}>
          <img
            src='https://www.paypalobjects.com/images/Cause/ic_critical_lg.svg'
            alt='confirmpng'
            height='82'
            width='82'
          />
        </div>
        <div className={styles.errorModalContent}>
          <HeadingText as='h2' size='md'>
            {i18n('label.checkout-error-title')}
          </HeadingText>
          <BodyText className={styles.errorModalSubtitle} as='p' size='md'>
            {i18n('label.checkout-error-subTitle')}
          </BodyText>
        </div>
      </>
    </Modal>
  );
});

export default CheckoutError;
